<template>
  <span v-if="name" class="badge-site" :style="{ background: colors.bg, color: colors.color }">
    <span class="badge-dot" :style="{ background: colors.dot }"></span>
    {{ name }}
  </span>
  <span v-else class="badge-empty">—</span>
</template>

<script>
const SITE_COLORS = {
  'Construct':  { bg: '#FFF4E6', color: '#C27C0E', dot: '#F59E0B' },
  'Kismetál': { bg: '#E8F0FF', color: '#2B55C5', dot: '#4B7BF5' },
};

export default {
  name: 'DepBadge',
  props: {
    name: { type: String, default: null },
  },
  computed: {
    colors() {
      return SITE_COLORS[this.name] || { bg: '#F0F2F7', color: '#4A5068', dot: '#9DA5C0' };
    },
  },
};
</script>

<style scoped>
.badge-site {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}
.badge-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
}
.badge-empty {
  color: #C5CAD8;
}
</style>